import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState("pending");
  const { setUser } = useAuth();

  useEffect(() => {
    const id = params.get("session_id");
    let tries = 0;
    let timer;
    const poll = async () => {
      tries += 1;
      try {
        const r = await api.get(`/payments/status/${id}`);
        if (r.data.payment_status === "paid") {
          const me = await api.get("/auth/me").catch(() => null);
          if (me) setUser(me.data);
          return setState("paid");
        }
        if (["expired", "failed"].includes(r.data.status)) return setState("failed");
      } catch (e) {
        if (e.response?.status === 404) return setState("failed");
      }
      if (tries < 15) timer = setTimeout(poll, 2000);
      else setState("timeout");
    };
    if (id) poll();
    else setState("failed");
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const view = {
    pending: [Loader2, "Confirmation du paiement…", "Merci de patienter quelques secondes.", "animate-spin text-[#1559d6]"],
    paid: [CheckCircle2, "Abonnement activé", "Merci ! Votre formule est active. Une facture vous est envoyée par Stripe.", "text-teal-600"],
    failed: [XCircle, "Paiement non abouti", "Aucune somme n'a été prélevée. Vous pouvez réessayer.", "text-red-500"],
    timeout: [Loader2, "Paiement en cours de traitement", "La confirmation prend plus de temps que prévu : actualisez la page Abonnement dans quelques minutes.", "text-amber-500"],
  }[state];
  const [Icon, title, text, cls] = view;
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#f6f8fb] px-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center" data-testid={`payment-${state}`}>
        <Icon className={`mx-auto h-12 w-12 ${cls}`} />
        <h1 className="mt-4 text-2xl font-bold text-slate-900">{title}</h1>
        <p className="mt-2 text-sm text-slate-600">{text}</p>
        {state !== "pending" && <Link to="/app/abonnement" data-testid="payment-back-link" className="mt-6 inline-block rounded-full bg-[#0b2c6b] px-5 py-2.5 text-sm font-semibold text-white">Retour à mon abonnement</Link>}
      </div>
    </div>
  );
}
